import { makeStyles } from 'tss-react/mui';

const useStylesFilterDateField: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  filterDateField: {
    width: '50%',
    margin: '15px auto',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  filterDateFieldLabel: {
    background: theme.palette.common.white,
    padding: '0 5px !important',
    marginLeft: -4,
  },
}));

export default useStylesFilterDateField;
